export enum QUOTATION_CATEGORY_KEYS {
	MASTER_PLAN = 'MASTER_PLAN'
}

export const QUOTATION_CATEGORIES = {
	[QUOTATION_CATEGORY_KEYS.MASTER_PLAN]: {
		key: QUOTATION_CATEGORY_KEYS.MASTER_PLAN,
		label: 'Master Plan'
	}
};

export enum QUOTATION_SUB_CATEGORY_KEYS {
	FLOOR_PLAN = 'FLOOR_PLAN'
}

export const QUOTATION_SUB_CATEGORIES = {
	[QUOTATION_SUB_CATEGORY_KEYS.FLOOR_PLAN]: {
		key: QUOTATION_SUB_CATEGORY_KEYS.FLOOR_PLAN,
		label: 'Floor Plan'
	}
};

export const typeOptions = ['ELITE', 'ELEGANT', 'LITE'];

export const SORT_QUOTATION_COLUMN_KEYS = {
	areaName: 'AREA_NAME',
	scope: 'SCOPE',
	quantity: 'QUANTITY',
	total: 'TOTAL'
};

export enum QUOTATION_BUDGET_TYPE_KEYS {
	LITE = 'LITE',
	ELEGANT = 'ELEGANT',
	ELITE = 'ELITE'
}

export const QUOTATION_BUDGET_TYPES = {
	[QUOTATION_BUDGET_TYPE_KEYS.LITE]: {
		key: QUOTATION_BUDGET_TYPE_KEYS.LITE,
		label: 'Lite'
	},
	[QUOTATION_BUDGET_TYPE_KEYS.ELEGANT]: {
		key: QUOTATION_BUDGET_TYPE_KEYS.ELEGANT,
		label: 'Elegant'
	},
	[QUOTATION_BUDGET_TYPE_KEYS.ELITE]: {
		key: QUOTATION_BUDGET_TYPE_KEYS.ELITE,
		label: 'Elite'
	}
};

export enum QUOTATION_UNIT_OF_MEASURE_KEYS {
	SQFT = 'SQFT',
	UNIT = 'UNIT'
}

export const QUOTATION_UNIT_OF_MEASURES = {
	[QUOTATION_UNIT_OF_MEASURE_KEYS.SQFT]: {
		key: QUOTATION_UNIT_OF_MEASURE_KEYS.SQFT,
		label: 'Sqft'
	},
	[QUOTATION_UNIT_OF_MEASURE_KEYS.UNIT]: {
		key: QUOTATION_UNIT_OF_MEASURE_KEYS.UNIT,
		label: 'Unit'
	}
};

export const calculateSqFtTotal = product => {
	const { unitOfMeasure, calculation, measurement, unitCost, quantity } = product;
	if (unitOfMeasure === 'SQFT') {
		const variables = {
			W: measurement?.width,
			H: measurement?.height,
			D: measurement?.depth,
			Area: measurement?.area,
			R: unitCost
		};
		let total;
		try {
			total = eval(calculation?.replace(/[A-Za-z]+/g, match => variables[match])) || 0;
		} catch (e) {
			total = 0;
		}

		return (total * quantity) / 92903.04;
	} else {
		return product.unitCost * quantity;
	}
};

export const calculateTotal = product => {
	const priceAdjustment = product?.grossUpPriceAdjustment ?? product?.gross_up_price_adjustment;
	if (priceAdjustment?.applied === true && product.priceIsBase !== true && Number.isFinite(Number(product.price))) return Math.round(Number(product.price));
	const { unitOfMeasure, calculation, measurement, unitCost, quantity, builder, price } = product;
	if (builder) {
		return price;
	} else if (unitOfMeasure === 'SQFT') {
		const variables = {
			W: measurement?.width,
			H: measurement?.height,
			D: measurement?.depth,
			Area: measurement?.area,
			R: unitCost
		};
		let total;
		try {
			total = eval(calculation?.replace(/[A-Za-z]+/g, match => variables[match])) || 0;
		} catch (e) {
			total = 0;
		}

		return (total * quantity) / 92903.04;
	} else {
		return product.unitCost * quantity;
	}
};

export const getEditableFields = (calculation: string) => {
	if (!calculation) return [];

	const fields: Record<string, string> = {
		W: 'width',
		H: 'height',
		D: 'depth',
		A: 'area'
	};

	return Object.keys(fields)
		.filter(key => calculation.includes(key))
		.map(key => fields[key]);
};

export enum FC_BUILDER_KEYS {
	FLAT = 'FLAT',
	PERIPHERAL = 'PERIPHERAL',
	TABLE_TOP = 'TABLE_TOP'
}

export const FC_BUILDERS = {
	[FC_BUILDER_KEYS.FLAT]: {
		key: FC_BUILDER_KEYS.FLAT,
		label: 'FLAT'
	},
	[FC_BUILDER_KEYS.PERIPHERAL]: {
		key: FC_BUILDER_KEYS.PERIPHERAL,
		label: 'Peripheral'
	},
	[FC_BUILDER_KEYS.TABLE_TOP]: {
		key: FC_BUILDER_KEYS.TABLE_TOP,
		label: 'Table Top(TT)'
	}
};

export enum FC_BUILDER_CUT_DIRECTION_KEYS {
	LENGTH = 'LENGTH',
	BREADTH = 'BREADTH',
	BOTH = 'BOTH'
}

export const FC_BUILDER_CUT_DIRECTIONS = {
	[FC_BUILDER_CUT_DIRECTION_KEYS.LENGTH]: {
		key: FC_BUILDER_CUT_DIRECTION_KEYS.LENGTH,
		label: 'Length'
	},
	[FC_BUILDER_CUT_DIRECTION_KEYS.BREADTH]: {
		key: FC_BUILDER_CUT_DIRECTION_KEYS.BREADTH,
		label: 'Breadth'
	},
	[FC_BUILDER_CUT_DIRECTION_KEYS.BOTH]: {
		key: FC_BUILDER_CUT_DIRECTION_KEYS.BOTH,
		label: 'Both'
	}
};

export enum LED_LIGHT_CUTS_KEYS {
	NONE = 'NONE',
	ONE_SIDE = 'ONE_SIDE',
	BOTH_SIDE = 'BOTH_SIDE'
}

export const LED_LIGHT_CUTS = {
	[LED_LIGHT_CUTS_KEYS.NONE]: {
		key: LED_LIGHT_CUTS_KEYS.NONE,
		label: 'No Cove Lighting'
	},
	[LED_LIGHT_CUTS_KEYS.ONE_SIDE]: {
		key: LED_LIGHT_CUTS_KEYS.ONE_SIDE,
		label: 'One Side'
	},
	[LED_LIGHT_CUTS_KEYS.BOTH_SIDE]: {
		key: LED_LIGHT_CUTS_KEYS.BOTH_SIDE,
		label: 'Both Side'
	}
};

export enum LIGHTING_INTENSITY_KEYS {
	LOW = 'LOW',
	MEDIUM = 'MEDIUM',
	HIGH = 'HIGH'
}

export const LIGHTING_INTENSITIES = {
	[LIGHTING_INTENSITY_KEYS.LOW]: {
		key: LIGHTING_INTENSITY_KEYS.LOW,
		label: 'Low'
	},
	[LIGHTING_INTENSITY_KEYS.MEDIUM]: {
		key: LIGHTING_INTENSITY_KEYS.MEDIUM,
		label: 'Medium'
	},
	[LIGHTING_INTENSITY_KEYS.HIGH]: {
		key: LIGHTING_INTENSITY_KEYS.HIGH,
		label: 'High'
	}
};

export const WALL_TILES_CATEGORIES = {
	LITE: {
		key: 'LITE',
		label: 'Lite'
	},
	ELEGANT: {
		key: 'ELEGANT',
		label: 'Elegant'
	},
	ELITE: {
		key: 'ELITE',
		label: 'Elite'
	}
};

export const WALL_TILES_FINISHES = {
	GLOSSY: { key: 'GLOSSY', label: 'Glossy' },
	MATTE: { key: 'MATTE', label: 'Matte' },
	METALLIC: { key: 'METALLIC', label: 'Metallic' },
	HI_GLOSS: { key: 'HI_GLOSS', label: 'Hi-Gloss' }
};
